import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import BrandLogo from "@/components/BrandLogo";

/**
 * Global footer used on public landing and inside the app shell.
 * Variants:
 *  - "default"  → full footer with brand mark + © (used on landing)
 *  - "minimal"  → compact single-line footer (used inside the app shell)
 */
export default function Footer({ variant = "default" }) {
  const { user } = useAuth();
  const minimal = variant === "minimal";

  const linkClass = "hover:text-primary transition-colors";

  return (
    <footer
      className={
        minimal
          ? "py-4 border-t border-border bg-background"
          : "py-10 border-t border-border"
      }
      data-testid={`footer-${variant}`}
    >
      <div
        className={`${
          minimal ? "max-w-7xl px-4 lg:px-8" : "max-w-7xl px-6 lg:px-10"
        } mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-neutral-500`}
      >
        <div className="flex items-center gap-2 font-serif-heading text-neutral-700">
          <BrandLogo size={minimal ? 18 : 22} />
          AI Bridal Manager™
        </div>
        <nav className="flex items-center gap-4 sm:gap-5 flex-wrap justify-center">
          <Link to="/privacy" className={linkClass} data-testid="footer-link-privacy">
            Privacy Policy
          </Link>
          <Link to="/cookie" className={linkClass} data-testid="footer-link-cookie">
            Cookie Policy
          </Link>
          <Link to="/termini" className={linkClass} data-testid="footer-link-terms">
            Termini
          </Link>
          <Link to="/aggiornamenti" className={linkClass} data-testid="footer-link-changelog">
            Aggiornamenti
          </Link>
          {user && (
            <Link to="/app/privacy" className={linkClass} data-testid="footer-link-privacy-account">
              Gestione dati
            </Link>
          )}
        </nav>
        <div className="text-neutral-400">
          © {new Date().getFullYear()} · Realizzato con cura in Italia.
        </div>
      </div>
    </footer>
  );
}
